import { type FC } from "react";
import { useFormContext } from "react-hook-form";
import { Button } from "@root/shared/components/Button";
import { GuidanceBox } from "@root/shared/components/GuidanceBox";
import { MultipleChoiceQuestion } from "./uiParts/MultipleChoiceQuestion";
import { SingleChoiceQuestion } from "./uiParts/SingleChoiceQuestion";
import { followUpKey, type ReopenEnqueteFormValues } from "./schema";
import { type PresentationProps, type Question } from "./types";
import * as styles from "./styles.css";

const renderQuestion = (question: Question, index: number) => {
  const label = `${index + 1}.${question.text}`;
  const formField = {
    name: question.questionCode,
    followUpTextName: followUpKey(question.questionCode),
  };
  switch (question.questionType) {
    case "single_choice":
      return (
        <SingleChoiceQuestion question={label} options={question.options} formField={formField} />
      );
    case "multiple_choice":
      return (
        <MultipleChoiceQuestion question={label} options={question.options} formField={formField} />
      );
    default: {
      const unsupported: never = question.questionType;
      throw new Error(`再開アンケート: 未対応の question_type です (${String(unsupported)})`);
    }
  }
};

export const Presentation: FC<PresentationProps> = ({ questions }) => {
  const { formState } = useFormContext<ReopenEnqueteFormValues>();
  // 画面遷移までボタンを押せなくする
  const isSubmitDisabled = formState.isSubmitting || formState.isSubmitSuccessful;

  return (
    <>
      <GuidanceBox themeColor="pink" className={styles.guidance}>
        <p className={styles.guidanceTitle}>
          今後のサポート向上のため、掲載の再開理由を教えてください
        </p>
        <p className={styles.guidanceDetail}>
          皆さまにより快適にご活用いただくための必須項目となります。
          <br />
          お手数ですが以下の項目を選択し、「完了にする」ボタンを押してください。
        </p>
      </GuidanceBox>

      <div className={styles.questions}>
        {questions.map((question, index) => (
          <div key={question.questionCode}>{renderQuestion(question, index)}</div>
        ))}
      </div>

      <div className={styles.buttons}>
        <Button
          type="submit"
          theme={isSubmitDisabled ? "disabled" : "primary"}
          disabled={isSubmitDisabled}
          className={styles.button}
        >
          完了にする
        </Button>
      </div>
    </>
  );
};
